import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { DemandService } from 'app/views/appviews/demand.service';
import { IDtoOfferAdmissionEvidenceDetail } from 'app/shared/models/legal/demand/offer-admission-evidence-detail.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DatePipe } from '@angular/common';
import { DocumentService } from 'app/shared/services/document.service';
import { MatRadioChange } from '@angular/material';
import { IDtoPreliminaryAudienceEvidenceDetail } from 'app/shared/models/legal/demand/dto-preliminary-audience-evidence-detail.model';

@Component({
    selector: 'app-modal-audience-judgment-evidence',
    templateUrl: './modal-audience-judgment-evidence.template.html',
    styleUrls: ['./modal-audience-judgment-evidence.style.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ModalAudienceJudgmentEvidenceComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formEvidence: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */
    public onClose: Subject<IDtoPreliminaryAudienceEvidenceDetail>;

    private fileNameVoucherEvidence: string;
    private fileVoucherEvidence: File;
    private catalogTypeTest: Observable<IDtoCatalog[]>;
    private evidence: IDtoPreliminaryAudienceEvidenceDetail;
    private employeeId: number;
    private isSecond: boolean;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private demandService: DemandService
        , private spinner: NgxSpinnerService
        , private datePipe: DatePipe
        , private documentService: DocumentService) {
        this.initializeFormEvidence();
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.patchData();
    }
    private initializeFormEvidence() {
        this.formEvidence = this.formBuilder.group({
            moneyRequest: [null, [Validators.required]],
            requestedAmount: [null],
            comment: [null, [Validators.required, Validators.maxLength(2000)]],
            voucher: [null, [Validators.required]],
            concludeEvidence: [null, [Validators.required]],
        });
    }
    private radioChange($event: MatRadioChange) {
        switch ($event.source.name) {
            case 'moneyRequest':
                this.makeRequiredFields($event.value);
                break;
        }
    }
    private patchData(): void {
        this.formEvidence.patchValue(this.evidence);
        if (this.evidence.documentReleaseEvidence) {
            this.fileNameVoucherEvidence = this.evidence.documentReleaseEvidence.fileName;
            this.formEvidence.get('voucher').setValidators(null);
            this.formEvidence.get('voucher').updateValueAndValidity();
        }
    }
    private makeRequiredFields(value: boolean): void {
        if (value) {
            this.formEvidence.get('requestedAmount').setValidators([Validators.required]);
        } else {
            this.formEvidence.get('requestedAmount').setValidators(null);
        }
        this.formEvidence.get('requestedAmount').updateValueAndValidity();
    }
    private submit(): void {
        if (this.formEvidence.valid) {
            this.update();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
        }
    }
    private onFileSelectedVoucherEvidence(event) {

        this.fileVoucherEvidence = event.target.files[0];

        if (this.fileVoucherEvidence) {

            this.fileNameVoucherEvidence = this.fileVoucherEvidence.name;
        }
    }
    private onFileChange(event) {
        event.value = '';
    }
    private resetForm() {
        this.formEvidence.reset();
        this.fileNameVoucherEvidence = null;
    }
    private update(): void {
        const data = this.formEvidence.value as IDtoPreliminaryAudienceEvidenceDetail;
        
        this.evidence.moneyRequest = data.moneyRequest;
        this.evidence.requestedAmount = data.requestedAmount;
        this.evidence.comment = data.comment;
        this.evidence.concludeEvidence = data.concludeEvidence;
        this.spinner.show();
        data.preliminaryAudienceId = this.evidence.id;
        this.demandService.updatePreliminaryAudienceEvidenceDetail(this.evidence)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let item = x.data as IDtoPreliminaryAudienceEvidenceDetail;
                        if(this.fileVoucherEvidence) {
                            let name = '';
                            name = this.isSecond == true ? `${this.evidence.typeTestName}_Segundo` : this.evidence.typeTestName
                            this.uploadFileEvidence(item.id, true, this.fileVoucherEvidence, name);
                        }
                        this.onClose.next(item);
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private uploadFileEvidence(referenceId: number, isReplaced: boolean, file: File, name: string): void {
        this.spinner.show();
        let document = {} as IDtoDocument;
        const fileName = file.name;
        let sp = fileName.split('.').pop();
        let fileNameNew = `${this.employeeId}_AudienciaJuicioPrueba${name}_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
        document.fileName = fileNameNew;
        document.referenceId = referenceId;
        document.folder = 'AudienciaJuicioPruebas';
        document.module = 'Demand';
        document.name = `AudienciaJuicio_${name}`;
        document.acceptDuplicate = false;
        document.isReplaced = isReplaced;
        this.documentService.addDocument(document, file).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
                let document = res.data as IDtoDocument;
                //this.addModuleLog(document.id, 'addDocument', 'documents');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
}
